// extracted by mini-css-extract-plugin
module.exports = {"root":"AutoTestTheoryPage_root__2AIxN","subtitle":"AutoTestTheoryPage_subtitle__2Bc9X","text":"AutoTestTheoryPage_text__1HwZ9","links":"AutoTestTheoryPage_links__2qqLq"};